import { render, staticRenderFns } from "./FlowConfig01Detail.vue?vue&type=template&id=9ad4681c&scoped=true&"
import script from "./FlowConfig01Detail.vue?vue&type=script&lang=js&"
export * from "./FlowConfig01Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad4681c",
  null
  
)

export default component.exports